<form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-sidebar-shell">
  <div class="representatives-form__content astral-sidebar-content astral-stack-l">
    <header class="astral-stack-s">
      @if (dataContext.id) {
        <h2 class="astral-sidebar-heading">{{ 'REPRESENTATIVE.FORM.EDIT_HEADER' | translate }}</h2>
      } @else {
        <h2 class="astral-sidebar-heading">{{ 'REPRESENTATIVE.FORM.CREATE_HEADER' | translate }}</h2>
      }
      <app-information-block [text]="'REPRESENTATIVE.FORM.HEADER_INFO' | translate"></app-information-block>
    </header>

    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <astral-input [control]="form.controls['contactName']"></astral-input>
      <astral-input [control]="form.controls['contactEmail']" [type]="'email'" [inputMode]="'email'"></astral-input>
      <astral-input [control]="form.controls['contactPhoneNumber']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
      <astral-select [control]="form.controls['contactCategory']" [itemsSource]="categories"></astral-select>
      @if (idTypeSelection) {
        <astral-select [control]="form.controls['contactIdentificationType']" [itemsSource]="idTypeSelection"></astral-select>
      }
      @if (contactIdentificationType) {
        <div class="astral-grid-span-2">
          <app-contact-id [idType]="contactIdentificationType" [control]="form.controls['contactIdentification']"></app-contact-id>
          @if (existingContactName) {
            <div class="representatives-form__error">{{ 'TENANT.EXISTING_CONTACT' | translate }}: {{ existingContactName }}</div>
          }
        </div>
      }
    </astral-layout-group>

    <section class="astral-accordion-section">
      <div class="astral-stack-s">
        <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'REPRESENTATIVE.FORM.ACCESS_HEADER' | translate }}</h3>
        <app-information-block [text]="'REPRESENTATIVE.FORM.ACCESS_INFO' | translate"></app-information-block>
      </div>
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
        <astral-checkbox [control]="form.controls['faultNotificationsAccess']"></astral-checkbox>
        <astral-checkbox [control]="form.controls['invoicesAccess']"></astral-checkbox>
        @if (!isBrf) {
          <astral-checkbox [control]="form.controls['dwellingInspectionsAccess']"></astral-checkbox>
          <astral-checkbox [control]="form.controls['leaseAgreementsAccess']"></astral-checkbox>
        }
        <astral-checkbox [control]="form.controls['documentsAccess']"></astral-checkbox>
      </astral-layout-group>
    </section>

    @if (setLanguageRadio()) {
      <section class="astral-accordion-section">
        <div class="astral-stack-s">
          <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'REPRESENTATIVE.FORM.LANGUAGE_HEADER' | translate }}</h3>
          <app-information-block [text]="'REPRESENTATIVE.FORM.LANGUAGE_INFO' | translate"></app-information-block>
        </div>
        <astral-select [control]="form.controls['inviteCultureName']" [itemsSource]="cultures"></astral-select>
      </section>
    }

    @if (setInvitationButtons()) {
      <section class="astral-accordion-section">
        <div class="astral-stack-s">
          <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'REPRESENTATIVE.FORM.INVITE_HEADER' | translate }}</h3>
          <app-information-block [text]="'REPRESENTATIVE.FORM.INVITE_INFO' | translate"></app-information-block>
        </div>
        <div class="representatives-form__invite-actions">
          <astral-button variant="secondary" (click)="onSendEmail()" type="button" labelKey="REPRESENTATIVE.FORM.SEND_EMAIL_BUTTON"></astral-button>
          <astral-button variant="secondary" (click)="onCopyToClipboard()" type="button" [label]="dataContext.contactRegistrationKey">
            <img astralButtonIcon src="assets/icons/copy-to-clipboard-icon.png" alt="copy to clipboard" />
          </astral-button>
        </div>
      </section>
    }
  </div>

  <footer class="astral-sidebar-footer">
    <astral-button
      variant="primary"
      type="submit"
      [disabled]="submitButtonDisabled"
      [labelKey]="dataContext.id ? 'REPRESENTATIVE.FORM.EDIT_BUTTON' : 'REPRESENTATIVE.FORM.CREATE_BUTTON'"
    ></astral-button>
    <astral-button variant="secondary" (click)="onFormCancel()" type="button" labelKey="CANCEL_BTN"></astral-button>
    @if (dataContext.id) {
      <astral-button variant="secondary" type="button" icon="trash" labelKey="REPRESENTATIVE.FORM.DELETE_BUTTON" (click)="onDelete()"></astral-button>
    }
  </footer>
</form>
